import React from "react"

const PurchaseActiveIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
            <path d="M18.5 15.9286V9C18.5 5.22876 18.5 3.34315 17.3284 2.17157C16.1569 1 14.2712 1 10.5 1H9.5C5.72876 1 3.84315 1 2.67157 2.17157C1.5 3.34315 1.5 5.22876 1.5 9V18.5" stroke="#21A6AA" stroke-width="1.5" stroke-linecap="round" />
            <path d="M7 7.67347L8.40901 6.18691C9.15901 5.39564 9.53401 5 10 5C10.466 5 10.841 5.39564 11.591 6.18692L13 7.67347M10 5.08723L10 12" stroke="#21A6AA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M18.5 16H4C2.61929 16 1.5 17.1193 1.5 18.5C1.5 19.8807 2.61929 21 4 21H18.5" stroke="#21A6AA" stroke-width="1.5" stroke-linecap="round" />
            <path d="M18.5 16C17.1193 16 16 17.1193 16 18.5C16 19.8807 17.1193 21 18.5 21" stroke="#21A6AA" stroke-width="1.5" stroke-linecap="round" />
        </svg>
    )
}
export default PurchaseActiveIcon